import React, { ReactNode } from 'react';
import { Button } from '../button/Button';
import { LoadingButton } from '../button/LoadingButton';
import { BaseModal, BaseModalProps } from './BaseModal';

export interface FormModalProps extends BaseModalProps {
  onSubmit?: () => void;
  onCancel?: () => void;
  submitText?: string;
  cancelText?: string;
  loadingText?: string;
  isLoading?: boolean;
  canSubmit?: boolean;
  footer?: ReactNode;
}

export const FormModal: React.FC<FormModalProps> = ({
  onSubmit,
  onCancel,
  submitText = 'Submit',
  cancelText = 'Cancel',
  loadingText,
  isLoading = false,
  canSubmit = true,
  footer,
  children,
  onClose,
  ...baseProps
}) => {
  const defaultFooter = (
    <div className="flex items-center justify-end gap-3">
      <Button
        variant="outline"
        onClick={onCancel || onClose}
        disabled={isLoading}
      >
        {cancelText}
      </Button>
      <LoadingButton
        onClick={onSubmit}
        loading={isLoading}
        loadingText={loadingText}
        disabled={!canSubmit}
      >
        {submitText}
      </LoadingButton>
    </div>
  );

  return (
    <BaseModal
      {...baseProps}
      onClose={onClose}
      footer={footer || defaultFooter}
      contentClassName={baseProps.contentClassName ?? 'p-6'}
    >
      {children}
    </BaseModal>
  );
};
